export default "__VITE_ASSET__Dt140gtz__"